/**
 * Engine-neutral bridge for ProgramPoints, which renders on the channel cover
 * page (play-common) outside the player tree and therefore cannot receive a
 * seek callback as a prop. The active player registers a seeker while mounted;
 * ProgramPoints falls back to the TheoPlayer global when none is registered.
 * Once TheoPlayer is removed, this registry becomes ProgramPoints' only path.
 */

/**
 * Seeks the live stream to `secondsRewind` seconds behind the live edge.
 * Returns false when there is no player to seek (destroyed mid-click).
 */
export type ProgramPointSeeker = (secondsRewind: number) => boolean;

let activeSeeker: ProgramPointSeeker | null = null;

/** Returns the unregister function; a later registration wins. */
export const registerProgramPointSeeker = (seeker: ProgramPointSeeker): (() => void) => {
  activeSeeker = seeker;
  return () => {
    if (activeSeeker === seeker) activeSeeker = null;
  };
};

export const getProgramPointSeeker = (): ProgramPointSeeker | null => activeSeeker;
